import { Link } from "gatsby"
import React, { useEffect, useState } from "react"
import { Modal } from "react-bootstrap"
import "./ReservationModule.scss"
import { useForm } from "react-hook-form"
import { zodResolver } from "@hookform/resolvers/zod"
import { z } from "zod"
import Payment from "./Payment"

const ReservationModule = ({
  showModal,
  setShowModal,
  propertyData,
  bookingReqData,
  bookingDisplayData,
  paymentData,
}) => {
  const {
    register,
    formState: { errors },
    formState,
    reset,
    handleSubmit,
  } = useForm({
    resolver: zodResolver(
      z.object({
        firstName: z.string().min(1),
        lastName: z.string().min(1),
        email: z.string().email(),
        phone: z
          .string()
          .regex(/^[\d+]+$/, "Please enter a valid phone number")
          .min(4),
      })
    ),
  })

  const [showPaymentDetails, setShowPaymentDetails] = useState(false)
  const [showStripePayment, setShowStripePayment] = useState(false)

  const [reservationData, setReservationData] = useState(null)

  useEffect(() => {
    if (formState.isSubmitSuccessful) {
      reset()
    }
  }, [formState, reset])

  useEffect(() => {
    if (showModal) {
      setShowPaymentDetails(false)
      setShowStripePayment(false)
      setReservationData(null)
    }
  }, [showModal])

  const onSubmit = data => {
    const { firstName, lastName, email, phone } = data
    const {
      accommodationCode,
      userCode,
      accommodationMasterCode,
      loginGA,
      adultsNumber,
      arrivalDate,
      departureDate,
      listingMapId,
      showGuestsInput
    } = bookingReqData

    // setReservationData({
    //   accommodationCode,
    //   userCode,
    //   accommodationMasterCode,
    //   loginGA,
    //   adultsNumber,
    //   arrivalDate,
    //   departureDate,
    //   name: firstName,
    //   surname: lastName,
    //   telephone: phone,
    //   email: email,
    //   fax: phone,
    //   dni: "",
    //   locality: "",
    //   postCode: "",
    //   city: "",
    //   country: "Dubai",
    //   isoCountryCode: "AE",
    //   telephone2: "",
    //   language: "en",
    //   documentType: "C",
    //   paymentMethod: 1,
    //   bookingType: "PAID",
    // })
    setReservationData({
      channelId: 2000, 
      listingMapId: listingMapId, 
      isManuallyChecked: 0,
      isInitial: 0,
      guestName: `${firstName}${lastName}`,
      guestFirstName: firstName,
      guestLastName: lastName,
      guestZipCode: null,
      guestAddress: null,
      guestCity: null,
      guestCountry: null,
      guestEmail: email,
      guestPicture: null,
      guestRecommendations: null,
      guestTrips: null,
      guestWork: null,
      isGuestIdentityVerified: null,
      isGuestVerifiedByEmail: null,
      isGuestVerifiedByWorkEmail:null,
      isGuestVerifiedByFacebook: null,
      isGuestVerifiedByGovernmentId: null,
      isGuestVerifiedByPhone: null,
      isGuestVerifiedByReviews: null,
      numberOfGuests: adultsNumber,
      adults:adultsNumber,
      children: null,
      infants: null,
      pets: null,
      arrivalDate: arrivalDate,
      departureDate: departureDate,
      checkInTime: null,
      checkOutTime: null,
      phone: phone,
      totalPrice: null,
      taxAmount: null,
      channelCommissionAmount: null,
      cleaningFee: null,
      securityDepositFee: null,
      isPaid: null,
      currency: "AED",
      hostNote: null,
      guestNote: null,
      guestLocale: null,
      doorCode: null,
      doorCodeVendor: null,
      doorCodeInstruction: null,
      comment: null,
      customerUserId: null
    })
    // get the ISO 3166-1 alpha-2 country code from the country name

    setShowPaymentDetails(true)
  }

  return (
    <div className="reservation-module-wrap">
      <Modal
        show={showModal}
        onHide={() => {
          setShowModal(false)
          setShowPaymentDetails(false)
        }}
        className="reservation-modal"
        centered
        backdropClassName="reservation-backdrop"
      >
        <Modal.Header closeButton className="reservation-model-header">
          <h2>Make a Reservation</h2>
        </Modal.Header>
        <Modal.Body className="reservation-modal-body">
          {showStripePayment && reservationData ? (
            <Payment
              reservationData={reservationData}
              paymentData={paymentData}
              propertyData={propertyData}
            />
          ) : showPaymentDetails ? (
            <>
              <div className="payement-details-card">
                <h4 className="title">
                  <span>Payment Details</span>
                </h4>
                <div className="payment-details-wrap">
                  {bookingDisplayData.displayData.map((data, i) => {
                    // Determine if the current item is the last one
                    const isLastItem = i === bookingDisplayData.displayData.length - 1;

                    return (
                      <React.Fragment key={i}>
                        {/* Render a divider before the last item */}
                        {isLastItem && (
                          <div className="payment-divider"></div>
                        )}
                        {/* Render the payment detail */}
                        <div
                          className={`payment-detail ${isLastItem ? 'total-amount' : ''}`}
                        >
                          <div className="payment-detail-label">
                            {data[0]}
                          </div>
                          <div className="payment-detail-value">
                            {data[1]}
                          </div>
                        </div>
                      </React.Fragment>
                    );
                  })}
                </div>

              </div>
              <button
                className="submit-button"
                onClick={() => setShowStripePayment(true)}
              >
                Proceed to payment
              </button>
            </>
          ) : (
            <div className="reservation-form-wrap">
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="reservation-form-inputs">
                  <div className="form-input">
                    <label>First Name</label>
                    <input
                      type="text"
                      placeholder=""
                      {...register("firstName")}
                    />
                    {errors?.firstName && (
                      <p className="error-message">
                        {errors.firstName.message}
                      </p>
                    )}
                  </div>
                  <div className="form-input">
                    <label>Last Name</label>
                    <input
                      type="text"
                      placeholder=""
                      {...register("lastName")}
                    />
                    {errors?.lastName && (
                      <p className="error-message">{errors.lastName.message}</p>
                    )}
                  </div>
                  <div className="form-input">
                    <label>Email</label>
                    <input type="text" placeholder="" {...register("email")} />
                    {errors?.email && (
                      <p className="error-message">{errors.email.message}</p>
                    )}
                  </div>
                  <div className="form-input">
                    <label>Telephone</label>
                    <input
                      type="number"
                      placeholder=""
                      {...register("phone")}
                    />
                    {errors?.phone && (
                      <p className="error-message">{errors.phone.message}</p>
                    )}
                  </div>
                </div>
                <button type="submit" className="submit-button">
                Proceed to payment
                </button>
              </form>
              <div className="terms-section">
                <p>
                  By clicking Submit, you agree to our{" "}
                  <Link to="/contact-arabian-estates/">Terms & Conditions</Link> and{" "}
                  <Link to="/contact-arabian-estates/">Privacy Policy</Link>.
                </p>
              </div>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default ReservationModule
